import Quill from 'quill';

const Parchment = Quill.import('parchment');

class VideoBlot extends Parchment.Embed {
  static create(url) {
    const node = super.create();

    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.style.maxWidth = '100%';

    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

VideoBlot.blotName = 'video';
VideoBlot.tagName = 'video';

export default VideoBlot;
